module.exports = __webpack_public_path__ + "static/media/Corn3V6-V8.c11a49d0.png";